var UitkTableCellTextAlignsMap = [
    ['left', 'textalign-left'],
    ['right', 'textalign-right'],
    ['center', 'textalign-center'],
    ['justify', 'textalign-justify'],
    ['justify-all', 'textalign-justify-all'],
    ['start', 'textalign-start'],
    ['end', 'textalign-end'],
    ['match-parent', 'textalign-match-parent']
];
var UitkTableCellTextAlign = new Map(UitkTableCellTextAlignsMap);
var UitkTableColInlineSizeMap = [
    ['10%', 'size-10-percent'],
    ['20%', 'size-20-percent'],
    ['30%', 'size-30-percent'],
    ['40%', 'size-40-percent'],
    ['50%', 'size-50-percent'],
    ['60%', 'size-60-percent'],
    ['70%', 'size-70-percent'],
    ['80%', 'size-80-percent'],
    ['90%', 'size-90-percent'],
    ['100%', 'size-100-percent']
];
var UitkTableColInlineSize = new Map(UitkTableColInlineSizeMap);
var UitkTableCellVerticalAlignsMap = [
    ['baseline', 'verticalalign-baseline'],
    ['sub', 'verticalalign-sub'],
    ['super', 'verticalalign-super'],
    ['text-top', 'verticalalign-text-top'],
    ['text-bottom', 'verticalalign-text-bottom'],
    ['middle', 'verticalalign-middle'],
    ['top', 'verticalalign-top'],
    ['bottom', 'verticalalign-bottom']
];
var UitkTableCellVerticalAlign = new Map(UitkTableCellVerticalAlignsMap);
var UitkTableRowsStripingMap = [
    ['odd', 'striped-odd'],
    ['even', 'striped-even']
];
var UitkTableRowsStriping = new Map(UitkTableRowsStripingMap);
var UitkTableOverflowMap = [['inline-scroll', 'inline-scroll']];
var UitkTableOverflow = new Map(UitkTableOverflowMap);
var UitkTableColumnSizeMap = [['equal', 'col-inlinesize-equal']];
var UitkTableColumnSize = new Map(UitkTableColumnSizeMap);
var UitkTableCellTag = {
    header: 'th',
    data: 'td'
};
var UitkTableCellBorder = {
    horizontal: 'horizontal',
    vertical: 'vertical'
};
var UitkTableCellHorizontalAlignmentMap = [
    ['leading', 'leading'],
    ['center', 'center'],
    ['trailing', 'trailing']
];
var UitkTableCellHorizontalAlignment = new Map(UitkTableCellHorizontalAlignmentMap);
var UitkTableCellVerticalAlignmentMap = [
    ['top', 'top'],
    ['middle', 'middle'],
    ['bottom', 'bottom']
];
var UitkTableCellVerticalAlignment = new Map(UitkTableCellVerticalAlignmentMap);
var UitkTableCellPadding = {
    standard: 'standard',
    graphic: 'graphic',
    zero: 'zero'
};
var UitkTableSortIconName = {
    ascending: 'sort_ascending',
    descending: 'sort_descending',
    default: 'swap_vert'
};
var UitkTableSortDirectionMap = [
    ['ascending', 'ascending'],
    ['descending', 'descending']
];
var UitkTableSortDirection = new Map(UitkTableSortDirectionMap);
var UitkTableFrozenColumnDirectionMap = [
    ['leading', 'leading'],
    ['trailing', 'trailing']
];
var UitkTableFrozenColumnDirection = new Map(UitkTableFrozenColumnDirectionMap);
var UitkTableCaptionAlignmentMap = [
    ['start', 'start'],
    ['end', 'end']
];
var UitkTableCaptionAlignment = new Map(UitkTableCaptionAlignmentMap);
var UitkTableCellHeaderScope = {
    column: 'col',
    rowColumn: 'row'
};
var UitkTableCellHighlight = {
    highlight: 'highlight',
    highlightAlternate: 'highlight-alternate'
};

export { UitkTableCaptionAlignment, UitkTableCellBorder, UitkTableCellHeaderScope, UitkTableCellHighlight, UitkTableCellHorizontalAlignment, UitkTableCellHorizontalAlignmentMap, UitkTableCellPadding, UitkTableCellTag, UitkTableCellTextAlign, UitkTableCellVerticalAlign, UitkTableCellVerticalAlignment, UitkTableCellVerticalAlignmentMap, UitkTableColInlineSize, UitkTableColumnSize, UitkTableFrozenColumnDirection, UitkTableOverflow, UitkTableRowsStriping, UitkTableSortDirection, UitkTableSortDirectionMap, UitkTableSortIconName };
